const reward_system_home = 'reward-system'
export const reward_system_routes = {
    reward_system_home: `/${reward_system_home}`
}
export default reward_system_routes